import isEmpty from 'validator/es/lib/isEmpty'
import trim from 'validator/es/lib/trim'
import isLength from 'validator/es/lib/isLength'
import isEmail from 'validator/es/lib/isEmail'

const validationHelper = {
  // Validate search field
  validateSearchField: function (query) {
    return query !== undefined && !isEmpty(trim(query))
  },
  // Validate name format
  validateNameEmpty: function (name) {
    return name !== undefined && !isEmpty(trim(name))
  },

  // Validate name format
  validateNameFormat: function (name) {
    const regx = /[<>$+*/&\\~.#{|^@()[\]}%=!:;£?"]/
    return !regx.test(trim(name)) && isLength(trim(name), { min: 1, max: 30 })
  },

  // Validate subject format
  validateSubject: function (subject) {
    const regx = /[<>$+*/&\\~.#{|^@()[\]}%=!:;£?"]/
    return subject !== undefined && !isEmpty(subject) && !regx.test(subject)
  },

  // Validate issue format
  validateIssue: function (issue) {
    const regx = /[<>$+*/&\\~.#{|^@()[\]}%=!:;£?"]/
    return issue !== undefined && !isEmpty(issue) && !regx.test(issue)
  },

  // Validate order number format
  validateOrderNumber: function (orderNumber) {
    const regx = /[<>$+*/&\\~.#{|^@()[\]}%=!:;£?"]/
    return (
      orderNumber === undefined ||
      (orderNumber !== undefined && isEmpty(trim(orderNumber))) ||
      (orderNumber !== undefined && !isEmpty(trim(orderNumber)) && !regx.test(trim(orderNumber)))
    )
  },

  // Validate order number format
  validatePhoneNumber: function (phoneNumber) {
    const regx = /^[+]{0,1}[0-9]{1,19}$/
    return (
      phoneNumber === undefined ||
      (phoneNumber !== undefined && isEmpty(trim(phoneNumber))) ||
      (phoneNumber !== undefined && !isEmpty(trim(phoneNumber)) && regx.test(trim(phoneNumber)))
    )
  },

  // Validate email address empty
  validateEmailAddressEmpty: function (email) {
    return email !== undefined && !isEmpty(trim(email))
  },

  // Validate email existing @
  validateEmailExistingAt: function (email) {
    return email !== undefined && trim(email).includes('@')
  },

  // Validate email address
  validateEmailAddress: function (email) {
    return email !== undefined && isEmail(trim(email))
  },

  // Validate company format
  validateCompany: function (company) {
    const regx = /[<>"]/
    return (
      company === undefined ||
      (company !== undefined && isEmpty(trim(company))) ||
      (company !== undefined && !isEmpty(trim(company)) && !regx.test(trim(company)))
    )
  },

  // Validate comment empty
  validateCommentEmpty: function (comment) {
    return comment !== undefined && isLength(trim(comment), { min: 1 })
  },

  // Validate comment format
  validateCommentFormat: function (comment) {
    const regx = /[<>"]/
    return comment !== undefined && !isEmpty(trim(comment)) && !regx.test(trim(comment))
  },

  // Validate search help center format
  validateSearchHelpCenter: function (helpCenter) {
    // const regx = /[<>\$+\*/&\\~.#{|^@()\[\]\}%=!:;£?"]/;
    return helpCenter !== undefined && !isEmpty(trim(helpCenter)) // && !regx.test(helpCenter);
  },
}

export default validationHelper
